interface LoadingGridProps {
  count?: number;
  columns?: string;
}

export default function LoadingGrid({
  count = 8,
  columns = "grid-cols-1 sm:grid-cols-2 lg:grid-cols-4",
}: LoadingGridProps) {
  return (
    <div className={`grid gap-4 md:gap-5 ${columns}`}>
      {Array.from({ length: count }).map((_, index) => (
        <div
          key={`skeleton-${index}`}
          className="overflow-hidden rounded-lg border border-background-200 bg-background-50"
        >
          <div className="aspect-video w-full animate-pulse bg-background-200"></div>
          <div className="space-y-3 p-4">
            <div className="h-4 w-3/4 animate-pulse rounded bg-background-200"></div>
            <div className="h-3 w-full animate-pulse rounded bg-background-100"></div>
            <div className="h-3 w-2/3 animate-pulse rounded bg-background-100"></div>
          </div>
        </div>
      ))}
    </div>
  );
}